import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {MeetingMinuteForm} from "./MeetingMinuteForm";
import {currentEffectiveUserId} from "../../../reducers/ui";
import {createMeetingMinutes} from "../../../actions/meetingMinutes";

const MeetingMinuteNew = props => {
  const { projectid, onSubmit, onCancel, userid } = props;
  return <Card title='Meeting Minutes Details' className={'edit-view'}>
    <MeetingMinuteForm projectid={projectid} onCancel={onCancel} onSubmit={onSubmit} userid={userid}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => ({ projectid: props.match.params.id, userid: currentEffectiveUserId(state) }),
    (dispatch, props) => ({
      onSubmit: (meetingMinutes) => {
        return dispatch(createMeetingMinutes(props.match.params.id, meetingMinutes, (meetingMinutesId) => props.history.push(`/projects/${props.match.params.id}/meeting-minutes/${meetingMinutesId}`)));
      },
      onCancel: () => props.history.goBack()
    })
  )
)(MeetingMinuteNew);



// WEBPACK FOOTER //
// ./src/components/Projects/MeetingMinutes/MeetingMinuteNew.js